export const UK_REGIONS = [
  "East Midlands",
  "Eastern Counties",
  "North West",
  "South West",
  "Southern",
  "West Midlands",
  "Yorkshire"
];

export const UK_REGIONS_TO_CODE_MAP: Record<string, string> = {
  "West Midlands": "10",
  "East Midlands": "15",
  Southern: "20",
  "North West": "30",
  Yorkshire: "40",
  "South West": "50",
  "Eastern Counties": "60"
};

export const CODE_TO_UK_REGIONS_MAP: Record<string, string> = {
  "10": "West Midlands",
  "15": "East Midlands",
  "20": "Southern",
  "30": "North West",
  "40": "Yorkshire",
  "50": "South West",
  "60": "Eastern Counties"
};

export const BUSINESS_UNIT_TO_CODE_MAP: Record<string, string> = {
  "10": "10 - West Midlands",
  "15": "15 - East Midlands",
  "20": "20 - Southern",
  "30": "30 - North West",
  "40": "40 - Yorkshire",
  "50": "50 - South West",
  "60": "60 - Eastern Counties"
};
